module.exports = __webpack_public_path__ + "static/media/logo-rt132-2024.c34a2f73.png";